import React from "react";
import {useState, useEffect} from "react";
import window from "../lib/WindowExtended";
import {useMediaQuery} from "react-responsive";

const BackToTopButton: React.FC<{position?: number}> = ({position = 0}) => {
  const [visible, setVisible] = useState(false);
  const isMobile = useMediaQuery({query: "(max-width: 767px)"});

  // do not show back-to-top button on mobile Samsung Internet Browser (because it has an own user agent back-to-top button)
  if (
    isMobile &&
    navigator.userAgent.match(/SAMSUNG|Samsung|SGH-[I|N|T]|GT-[I|N]|SM-[A|N|P|T|Z]|SHV-E|SCH-[I|J|R|S]|SPH-L/i)
  ) {
    return null;
  }

  useEffect(() => {
    window.addEventListener("scroll", showButton);

    return () => window.removeEventListener("scroll", showButton);
  }, []);

  const showButton = () => {
    if (window.scrollY > 400) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };
  const scrollToTop = () => {
    document.body.scrollTop = position; // Safari
    document.documentElement.scrollTop = position; // Alle anderen Browser
  };

  return (
    <>
      {visible && (
        <span onClick={scrollToTop} className="back-to-top">
          <span className="back-to-top__button">
            <i className="icon icon-top" />
          </span>
        </span>
      )}
    </>
  );
};

export default BackToTopButton;
